import { isPlatformServer } from '@angular/common';
import {
  EnvironmentProviders,
  Inject,
  inject,
  makeEnvironmentProviders,
  ModuleWithProviders,
  NgModule,
  Optional,
  PLATFORM_ID,
  SkipSelf,
} from '@angular/core';

import { PartialBy } from '@personal-area/common';
import { StorageConfig } from './models/config.model';
import { STORAGE_CONFIG } from './tokens/config.token';

@NgModule()
export class StorageModule {

  static forRoot(config: PartialBy<StorageConfig, 'isServer'>): ModuleWithProviders<StorageModule> {
    return {
      ngModule: StorageModule,
      providers: [
        {
          provide: STORAGE_CONFIG,
          useFactory: () => {
            const platformId = inject(PLATFORM_ID);

            return {
              isServer: isPlatformServer(platformId),
              ...config,
            };
          },
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: StorageModule,
    @Inject(STORAGE_CONFIG) config: StorageConfig,
  ) {
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import module in the AppModule only.`);
    }
  }
}

// Standalone way of the same as above
export function provideStorage(
  config: PartialBy<StorageConfig, 'isServer'>,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: STORAGE_CONFIG,
      useFactory: () => {
        const platformId = inject(PLATFORM_ID);

        return {
          isServer: isPlatformServer(platformId),
          ...config,
        };
      },
    },
  ]);
}
